









































import { RentalStatusEnum } from "@/lib/enum/rental-status.enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IRental, Rental } from "@/models/rental.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {},
  filters: {}
})
export default class RentalReturnDialog extends mixins(PermissionMixin, RulesMixin) implements IDialog {
  @Prop({ default: false }) value!: boolean;
  @Prop() rental!: IRental;

  dialog: boolean = this.value;
  isLoading = false;
  isEditValid = false;

  editRental: IRental | null = null;

  async returnRental() {
    if (!this.editRental) {
      return;
    }
    this.isLoading = true;
    try {
      await this.editRental.updatePartial({
        returnDate: this.editRental.returnDate,
        status: RentalStatusEnum.COMPLETED
      });
      this.rental.map(this.editRental);
      this.close();
    } catch (error) {
      handleError(error);
    } finally {
      this.isLoading = false;
    }
  }

  @Watch("value")
  onValueChange(val: boolean) {
    if (val) {
      this.editRental = new Rental(this.rental);
    }
    this.dialog = val;
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  open() {
    this.dialog = true;
  }

  close() {
    this.dialog = false;
  }
}
